import { Link } from 'react-router-dom';
import { useRuntimeBrand } from '@core/hooks/useRuntimeBrand';
import PoweredBy from '@components/base/PoweredBy';
import { useIndustry } from '@/app/providers/industry-context.js';
import { useCopy } from '@/app/providers/useCopy';

export default function FooterDemo() {
  const t = useCopy();
  const { config } = useIndustry();
  const { brandName: runtimeBrandName } = useRuntimeBrand();
  const year = new Date().getFullYear();
  const appName = runtimeBrandName || config?.copy?.appName || config?.name || 'Bytz';

  return (
    <footer
      style={{
        marginTop: 64,
        padding: '2.5rem 1.5rem',
        background: 'var(--color-primary)',
        color: '#fff',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          maxWidth: 720,
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          alignItems: 'center',
        }}
      >
        <strong
          style={{
            fontSize: 22,
            fontFamily: 'var(--font-display)',
            letterSpacing: '0.03125rem',
            textTransform: 'uppercase',
          }}
        >
          {appName}
        </strong>
        <nav
          style={{
            display: 'flex',
            gap: 16,
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}
        >
          <Link to="/catalog" style={{ color: 'inherit', opacity: 0.85 }}>
            {t('shop', 'Shop')}
          </Link>
          <Link to="/orders" style={{ color: 'inherit', opacity: 0.85 }}>
            {t('orders', 'Orders')}
          </Link>
          <Link to="/account" style={{ color: 'inherit', opacity: 0.85 }}>
            {t('account', 'Account')}
          </Link>
        </nav>
        <div style={{ fontSize: 13, opacity: 0.75 }}>
          © {year} · {appName} · {t('allRightsReserved', 'All rights reserved').replace(/\.$/, '')}{' '}
          · <PoweredBy />
        </div>
      </div>
    </footer>
  );
}
